export default __webpack_public_path__ + "static/media/icon-sass.baccad57.svg";